import ExposedFilter from './ExposedFilter';

export default ExposedFilter;
